<div class="viewport-1">
  <student-header #studentHeader></student-header>
  <side-menu #sideMenu (selectedAvatar)="updateSelectedAvatar($event)" [disabled]="disableSideButton"></side-menu>
  @if (showAwardedAvatar) {
    <div class="awarded-avatar-container">
      <img class="winning-team-avatar" [src]="awardedAvatar?.avatar" />
    </div>
  }
  <div id="first-screen" [class.screen-hide]="levelTwo" class="level-select-content-div" [style.background-image]="'url(' + levelSelectBackgroundImageA + ')'">
    <div class="level-div">
      @for (level of levelButtonList1; track level; let i = $index) {
        <button
          [attr.id]="level.id"
          class="level-btn"
          [style]="level.style"
          [disabled]="!enableAllButtons || level.disabled" (click)="goToTaskSelect(i)"
          (touchstart)="highlightLevelButton(i)" (touchend)="handleTouchEnd(level, i, $event)"
          (mouseover)="highlightLevelButton(i)" (mouseleave)="unhighlightLevelButton(i)">
        </button>
      }
    </div>
    @if (!isDemoUser && !playTransition) {
      <button id="avatar" class="avatar-div" [style]="avatarPosition" [disabled]="!enableAllButtons" (click)="goToTaskSelect()"></button>
    }
  </div>
  @if (isIntervention) {
    <div id="second-screen" class="level-select-content-div"
      [class]="{'screen-show' : levelTwo, 'screen-up' : transitionDirection === 'Up', 'screen-down' : transitionDirection === 'Down', 'screen-left' : transitionDirection === 'Left', 'screen-right' : transitionDirection === 'Right'}"
      [style.background-image]="'url(' + levelSelectBackgroundImageB + ')'">
      <div class="level-div">
        @for (level of levelButtonList2; track level; let i = $index) {
          <button
            [attr.id]="level.id"
            class="level-btn"
            [style]="level.style"
            [disabled]="!enableAllButtons || level.disabled"
            (click)="goToTaskSelect(i)"
            (touchstart)="highlightLevelButton(i)" (touchend)="handleTouchEnd(level, i, $event)"
            (mouseover)="highlightLevelButton(i)" (mouseleave)="unhighlightLevelButton(i)">
          </button>
        }
      </div>
      @if (isIntervention && !isDemoUser) {
        <button id="avatar" class="avatar-div" [style]="avatarPosition" [disabled]="!enableAllButtons" (click)="goToTaskSelect()"></button>
      }
    </div>
  }
  <div class="fireworks-panel"></div>
  @if (displayCompletedMessage) {
    <congratulations></congratulations>
  }
  <instructions [videoSource]="videoSource" #instructions></instructions>
  <student-footer #studentFooter timerBackgroundImage="/assets/images/timer/timerLabel-level.svg"></student-footer>
</div>